import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import FileIcon from '@atlaskit/icon/glyph/file';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { UnstyledButton } from '@atlassian/help-center-common-component/unstyled-button';
import i18n from '../messages';
import {
    UploadProgressBarContainer,
    UploadProgressBarInProgress,
    UploadProgressBarFailure,
    AttachmentContainer,
    AttachmentFileName,
    AttachmentMessage,
    UploadStatusPreview,
} from './styled';

export interface UploadStatusProps {
    id: string;
    name: string;
    mimeType: string;
    size: number;
    publicId?: string;
    preview?: string;
    progress?: number;
    failed?: boolean;
    error?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onRemove?: () => any;
}

export class UploadStatus extends React.PureComponent<UploadStatusProps & InjectedIntlProps> {
    renderProgressBar() {
        if (this.props.failed) {
            return (
                <UploadProgressBarContainer>
                    <UploadProgressBarFailure />
                </UploadProgressBarContainer>
            );
        }
        const progress = this.props.progress || 0;
        return (
            <UploadProgressBarContainer>
                <UploadProgressBarInProgress progress={progress} />
            </UploadProgressBarContainer>
        );
    }

    onRemove = () => {
        this.props.onRemove && this.props.onRemove();
    };

    renderRightIcon() {
        const iconProps = {
            label: this.props.intl.formatMessage(i18n.attachmentRemoveLabel),
            primaryColor: token('color.icon', colors.N500),
        };
        return (
            <UnstyledButton onClick={this.onRemove} actionSubjectId="removeAttachment">
                <CrossIcon {...iconProps} size="medium" />
            </UnstyledButton>
        );
    }

    render() {
        const { name, preview, failed, error, intl } = this.props;
        const icon = preview ? (
            <UploadStatusPreview alt={intl.formatMessage(i18n.attachmentRemoveLabel)} src={preview} />
        ) : (
            <FileIcon label={intl.formatMessage(i18n.attachmentRemoveLabel)} size="large" />
        );
        const content = (
            <React.Fragment>
                <AttachmentContainer>
                    <AttachmentFileName title={name}>{name}</AttachmentFileName>
                    {failed && (
                        <AttachmentMessage title={error}>
                            {intl.formatMessage(i18n.attachmentUploadFailed)}
                        </AttachmentMessage>
                    )}
                </AttachmentContainer>
                {this.renderProgressBar()}
            </React.Fragment>
        );
        return <IconCardLayout leftIcon={icon} content={content} rightIcon={this.renderRightIcon()} />;
    }
}

export default injectIntl(UploadStatus);
